import { render } from "./jobForm.vue?vue&type=template&id=b38e1884"
import script from "./jobForm.vue?vue&type=script&lang=js"
export * from "./jobForm.vue?vue&type=script&lang=js"

import "./jobForm.vue?vue&type=style&index=0&id=b38e1884&lang=css"
script.render = render

export default script